import React from "react";
import { formatRestrictionMessage, isChatMuted, isModuleReadonly } from "../utils/clientRestrictionsUi";

/**
 * Banner when the current network restriction blocks chat or a module.
 * @param {"chat"|"polls"|"requests"|"feedbacks"|"cars"} module
 */
const RestrictionNotice = ({ restriction, module = "chat", className = "" }) => {
    if (!restriction) return null;

    const blocked = module === "chat"
        ? isChatMuted(restriction)
        : isModuleReadonly(restriction, module);

    if (!blocked) return null;

    const text = formatRestrictionMessage(restriction, module);

    return (
        <div className={`restriction-notice ${className}`.trim()} role="status">
            {text}
        </div>
    );
};

export default RestrictionNotice;
